export function validString(value: any): boolean
{
    return typeof value === 'string' && value.length > 0;
}

export function validInteger(value: any): boolean
{
    return typeof value === 'string' && /^\d+$/.test(value);
}
